import * as tslib_1 from "tslib";
import { themr } from '@nextiva/analytics-lib';
import React, { PureComponent } from 'react';
import { Popover, Switcher } from '@nextiva/next-ui';
import Styles from "./SwitcherPopover.css";

var SwitcherPopover =
/** @class */
function (_super) {
  tslib_1.__extends(SwitcherPopover, _super);

  function SwitcherPopover() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isOpen: false
    };

    _this.togglePopover = function () {
      _this.setState(function (state) {
        return {
          isOpen: !state.isOpen
        };
      });
    };

    _this.toggleSwither = function (value) {
      _this.props.handleChange(value);

      _this.togglePopover();
    };

    _this.renderBody = function () {
      var _a = _this.props,
          label = _a.label,
          value = _a.value,
          theme = _a.theme;
      return React.createElement("div", {
        className: theme.popoverBody
      }, React.createElement("div", {
        className: theme.popoverLabel
      }, label), React.createElement(Switcher, {
        checked: value,
        onChange: _this.toggleSwither,
        size: 26
      }));
    };

    return _this;
  }

  SwitcherPopover.prototype.render = function () {
    var _a = this.props,
        Icon = _a.iconComponent,
        value = _a.value,
        theme = _a.theme;
    var isOpen = this.state.isOpen;
    return React.createElement(Popover, {
      className: theme.switcherPopover,
      body: this.renderBody(),
      isOpen: isOpen,
      togglePopover: this.togglePopover
    }, React.createElement(Icon, {
      isActive: isOpen || value
    }));
  };

  return SwitcherPopover;
}(PureComponent);

export default themr(SwitcherPopover, Styles);